export default class RateVariation {

	constructor(id, paymentDateIndex, rate) {
		this.id               = id
		this.paymentDateIndex = paymentDateIndex
		this.rate             = rate
	}
	
	static createFromJson(json) {
		if (!json) return null;
		return new RateVariation(json.id, json.paymentDateIndex, json.rate);
	}
}


// WEBPACK FOOTER //
// ./src/model/rate-variation.js